const PrinceGeoffrey = ({ size = 20, className = 'mb-3' }) => {
  return (
      <div className={`flex flex-col ${className}`}>
        <img src="/prince-geoffrey-2.png" width={size} height={size} className="" alt="" />
      </div>
  );
}

export default PrinceGeoffrey;
